import { useEffect, useRef, useState } from "react";

import jobCommandOneliner from "~/lib/jobCommandOneliner";
import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardPortal,
} from "~/components/shared/HoverCard";

function useIsTruncated(element: HTMLElement | null) {
  const [isTruncated, setIsTruncated] = useState(false);

  function updateIsTruncated() {
    if (!element) {
      return;
    }

    const isTruncated = element.scrollWidth > element.clientWidth;

    setIsTruncated(isTruncated);
  }

  useEffect(() => {
    updateIsTruncated();

    window.addEventListener("resize", updateIsTruncated);

    return () => {
      window.removeEventListener("resize", updateIsTruncated);
    };
  }, [element]);

  return isTruncated;
}

export default function Command({
  command,
  onNestedLinkTrigger,
}: {
  command: string;
  onNestedLinkTrigger: (e: React.MouseEvent | React.KeyboardEvent) => void;
}) {
  const commandRef = useRef<HTMLSpanElement>(null);
  const isTruncated = useIsTruncated(commandRef.current);

  return (
    <HoverCard>
      <HoverCardTrigger asChild={true}>
        <span className="small job-command flex min-w-0 flex-auto font-mono">
          <span className="pointer-events-none max-w-full truncate" ref={commandRef}>
            {jobCommandOneliner(command)}
          </span>
        </span>
      </HoverCardTrigger>

      {isTruncated && (
        <HoverCardPortal>
          <HoverCardContent
            size="max-lg"
            onClick={onNestedLinkTrigger}
            onKeyDown={onNestedLinkTrigger}
            data-testid="job-command-hover-card"
          >
            <pre className="small monospace whitespace-pre-wrap break-words">{command}</pre>
          </HoverCardContent>
        </HoverCardPortal>
      )}
    </HoverCard>
  );
}
